(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyber-favorites"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('he-favorites-carousel')) {
 customElements.define('he-favorites-carousel', class extends HTMLElement {
  connectedCallback() {
   this.track=this.querySelector('.cyber-favorites__grid');
   this.cards=Array.from(this.querySelectorAll('.cyber-favorites__card'));
   this.controls=this.querySelector('.cyber-favorites__controls');
   this.counter=this.querySelector('[data-counter]');
   this.pause=this.querySelector('[data-pause]');
   this.paused=false; this.visible=false;
   this.controller=new AbortController();
   const options={signal:this.controller.signal};
   this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),options);
   this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1),options);
   this.pause.hidden=this.dataset.autoplay!=='true';
   this.pause.addEventListener('click',()=>{
    this.paused=!this.paused;
    this.pause.setAttribute('aria-pressed',String(this.paused));
    this.pause.setAttribute('aria-label',this.paused?'Reanudar carrusel':'Pausar carrusel');
    this.pause.textContent=this.paused?'▶':'Ⅱ';this.start();
   },options);
   this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});
   this.track.addEventListener('keydown',event=>{
    if(event.target!==this.track)return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);}
   },options);
   this.addEventListener('mouseenter',()=>this.stop(),options);
   this.addEventListener('mouseleave',()=>this.start(),options);
   this.addEventListener('focusin',()=>this.stop(),options);
   this.addEventListener('focusout',()=>this.start(),options);
   this.addEventListener('touchstart',()=>this.stop(),{...options,passive:true});
   this.addEventListener('touchend',()=>this.start(),{...options,passive:true});
   document.addEventListener('visibilitychange',()=>this.start(),options);
   document.addEventListener('shopify:block:select',event=>{
    const card=this.cards.find(card=>card===event.target||card.contains(event.target));
    if(card){this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'instant'});this.stop();}
   },options);
   this.resize=new ResizeObserver(()=>{this.update();this.start();});this.resize.observe(this.track);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.start();},{threshold:0.2});
   this.observer.observe(this);
   this.update();
  }
  positions() {
   if(!this.cards.length)return [];
   const max=this.track.scrollWidth-this.track.clientWidth;
   const positions=this.cards.map(card=>Math.min(max,card.offsetLeft-this.cards[0].offsetLeft));
   return positions.filter((value,i)=>i===0||Math.abs(value-positions[i-1])>2);
  }
  current(positions) {
   return positions.reduce((best,value,i)=>Math.abs(value-this.track.scrollLeft)<Math.abs(positions[best]-this.track.scrollLeft)?i:best,0);
  }
  update() {
   const positions=this.positions();
   this.controls.hidden=positions.length<2;
   if(positions.length)this.counter.textContent=(this.current(positions)+1)+' / '+positions.length;
  }
  move(direction) {
   const positions=this.positions();
   if(positions.length<2)return;
   const next=(this.current(positions)+direction+positions.length)%positions.length;
   this.track.scrollTo({left:positions[next],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  stop(){clearInterval(this.timer);}
  start(){
   this.stop();
   if(this.dataset.autoplay!=='true'||this.paused||!this.visible||document.hidden||this.positions().length<2||this.matches(':hover')||this.contains(document.activeElement)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
   this.timer=setInterval(()=>this.move(1),Number(this.dataset.speed)||5000);
  }
  disconnectedCallback(){this.stop();this.controller.abort();this.resize.disconnect();this.observer.disconnect();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-mini-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cyber-mini-banner')) {
  customElements.define('cyber-mini-banner', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.index = 0;
      this.paused = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dots.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.go)), options));
      const pause = this.querySelector('[data-pause]');
      if (pause) pause.addEventListener('click', () => {
        this.paused = !this.paused;
        pause.setAttribute('aria-pressed', String(this.paused));
        pause.setAttribute('aria-label', this.paused ? 'Reanudar cambio automático' : 'Pausar cambio automático');
        pause.textContent = this.paused ? '▶' : 'Ⅱ';
        this.start();
      }, options);
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.start(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', () => this.start(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.show(index); this.stop(); }
      }, options);
      this.start();
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => { slide.hidden = i !== index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    }
    stop() { clearInterval(this.timer); }
    start() {
      this.stop();
      if (this.paused || this.dataset.autoplay !== 'true' || this.slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches || this.matches(':hover') || this.contains(document.activeElement)) return;
      this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), Number(this.dataset.speed) || 5000);
    }
    disconnectedCallback() { this.stop(); this.controller.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-packs"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('he-packs-carousel')) {
 customElements.define('he-packs-carousel', class extends HTMLElement {
  connectedCallback() {
   this.track=this.querySelector('.cyber-packs__grid');
   this.cards=Array.from(this.querySelectorAll('.cyber-packs__card'));
   this.controls=this.querySelector('.cyber-packs__controls');
   this.counter=this.querySelector('[data-counter]');
   this.pause=this.querySelector('[data-pause]');
   this.paused=false; this.visible=false;
   this.controller=new AbortController();
   const options={signal:this.controller.signal};
   this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),options);
   this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1),options);
   this.pause.hidden=this.dataset.autoplay!=='true';
   this.pause.addEventListener('click',()=>{
    this.paused=!this.paused;
    this.pause.setAttribute('aria-pressed',String(this.paused));
    this.pause.setAttribute('aria-label',this.paused?'Reanudar carrusel':'Pausar carrusel');
    this.pause.textContent=this.paused?'▶':'Ⅱ';this.start();
   },options);
   this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});
   this.track.addEventListener('keydown',event=>{
    if(event.target!==this.track)return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);}
   },options);
   this.addEventListener('mouseenter',()=>this.stop(),options);
   this.addEventListener('mouseleave',()=>this.start(),options);
   this.addEventListener('focusin',()=>this.stop(),options);
   this.addEventListener('focusout',()=>this.start(),options);
   this.addEventListener('touchstart',()=>this.stop(),{...options,passive:true});
   this.addEventListener('touchend',()=>this.start(),{...options,passive:true});
   document.addEventListener('visibilitychange',()=>this.start(),options);
   document.addEventListener('shopify:block:select',event=>{
    const card=this.cards.find(card=>card===event.target||card.contains(event.target));
    if(card){this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'instant'});this.stop();}
   },options);
   this.resize=new ResizeObserver(()=>{this.update();this.start();});this.resize.observe(this.track);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.start();},{threshold:0.2});
   this.observer.observe(this);
   this.update();
  }
  positions() {
   if(!this.cards.length)return [];
   const max=this.track.scrollWidth-this.track.clientWidth;
   const positions=this.cards.map(card=>Math.min(max,card.offsetLeft-this.cards[0].offsetLeft));
   return positions.filter((value,i)=>i===0||Math.abs(value-positions[i-1])>2);
  }
  current(positions) {
   return positions.reduce((best,value,i)=>Math.abs(value-this.track.scrollLeft)<Math.abs(positions[best]-this.track.scrollLeft)?i:best,0);
  }
  update() {
   const positions=this.positions();
   this.controls.hidden=positions.length<2;
   if(positions.length)this.counter.textContent=(this.current(positions)+1)+' / '+positions.length;
  }
  move(direction) {
   const positions=this.positions();
   if(positions.length<2)return;
   const next=(this.current(positions)+direction+positions.length)%positions.length;
   this.track.scrollTo({left:positions[next],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  stop(){clearInterval(this.timer);}
  start(){
   this.stop();
   if(this.dataset.autoplay!=='true'||this.paused||!this.visible||document.hidden||this.positions().length<2||this.matches(':hover')||this.contains(document.activeElement)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
   this.timer=setInterval(()=>this.move(1),Number(this.dataset.speed)||3000);
  }
  disconnectedCallback(){this.stop();this.controller.abort();this.resize.disconnect();this.observer.disconnect();}
 });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
